export default "__VITE_ASSET__08c3b143__"